import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    accountSettings_iin: 'ИИН заявителя',
    accountSettings_update: 'Обновить данные',
    accountSettings_updateFailed: 'Не удалось обновить данные пользователя',
    accountSettings_fillForm:
      'Уважаемый пользователь! Чтобы продолжить работу, необходимо заполнить обязательные поля! Для заполнения обязательных полей нужно нажать на кнопку "Редактировать", после cохранить личные данные нажав на кнопку "Сохранить".',

    accountSettingsDucks_loadRequesterFailed: 'Не удалось загрузить данные пользователя',
    accountSettingsDucks_saveRequesterFailed: 'Не удалось сохранить данные пользователя',
    accountSettingsDucks_saveRequesterSuccess: 'Данные успешно сохранены',
    accountSettingsDucks_lastLoginDt: 'Дата последнего успешного входа',
    accountSettings_myChildren:"Мои дети",
    accountSettings_updateChildrenData:'Обновить данные',

    accountSettingsPage_autoFillIntegration:
      'Для автоматического заполнения ваших данных в личном кабинете будет отправлено SMS-сообщение для получения вашего согласия на сбор и обработку данных.',
    home_agree: 'Я согласен ',
    home_donAgree: 'Я не согласен',
    accountSettings_errorUpdateChildInfo:'Не удалось обновить данные ребенка',
    accountSettings_myChildName:'Имя',
    accountSettings_myChildSurname:'Фамилия',
    accountSettings_myChildIIN:'ИИН',
    accountSettings_myChildBirthday:'Дата рождения',
    accountSettings_myChildGender:'Пол',
    accountSettings_myChildUpdateInfo:'Обновить',
    accountSettings_successUpdatedChildInfo:'Данные ребёнка успешно обновлены',
  },
  kk: {
    accountSettings_iin: 'ИИН заявителя',
    accountSettings_update: 'Деректерді жаңарту',
    accountSettings_updateFailed: 'Не удалось обновить данные пользователя',
    accountSettings_fillForm:
      'Құрметті пайдаланушы! Жұмысты жалғастыру үшін міндетті өрістерді толтыру қажет! Міндетті өрістерді толтыру үшін "Өңдеу" батырмасын басыңыз, кейін Өрістерді толтырғаннан кейін "Сақтау" батырмасын басу керек.',

    accountSettingsDucks_loadRequesterFailed: 'Не удалось загрузить данные пользователя',
    accountSettingsDucks_saveRequesterFailed: 'Не удалось сохранить данные пользователя',
    accountSettingsDucks_saveRequesterSuccess: 'Данные успешно сохранены',
    accountSettingsDucks_lastLoginDt: 'Соңғы сәтті кіру күні',

    accountSettingsPage_autoFillIntegration:
      'Жеке кабинетте деректеріңізді автоматты түрде толтыру үшін деректерді жинауға және өңдеуге келісіміңізді алу мақсатында SMS-хабарлама жіберіледі.',
    home_agree: 'Мен келісемін',
    home_donAgree: 'Мен қарсымын',
    accountSettings_updateChildrenData:'Деректерді жаңарту',
    accountSettings_errorUpdateChildInfo:'Баланың деректерін жаңарту мүмкін болмады',
    accountSettings_myChildName:'Аты',
    accountSettings_myChildSurname:'Тегі',
    accountSettings_myChildIIN:'ЖСН',
    accountSettings_myChildBirthday:'Туған күні',
    accountSettings_myChildGender:'Жынысы',
    accountSettings_myChildUpdateInfo:'Жаңарту',
    accountSettings_myChildren:"Менің балаларым",
    accountSettings_successUpdatedChildInfo:'Баланың деректері сәтті жаңартылды',
  }
});
